// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1DCjo","label":"SetPasswdForm_label__2mwyU"};